// 构建重定向URL
export function buildRedirectUrl(
  currentPath: string,
  nextPageUrlParams?: string
): string {
  const pathParts = currentPath.split('?')[0];
  const processSuffix = '/processing';
  let redirectUrl = `${pathParts}${processSuffix}`;

  if (nextPageUrlParams) {
    redirectUrl += nextPageUrlParams;
  }

  return redirectUrl;
}
